import getDeviceId from "./getDevicedId";
import { getOrigin } from "./getOrigin";
import { caijiUrl } from "./url";
import getParamsFromUrl from "@/js/getParamsFromUrl";

/**
 * 打开新闻埋点
 */
export function saveOpenArticle(articleID){
  const { nfhSpreadId } = getParamsFromUrl()
    $.ajax({
        url: caijiUrl,
        type: "GET",
        data: {
            dataType: 1000005,
            origin: getOrigin(),
            actionTime: new Date().getTime(),
            articleID,
            refer: document.referrer,
            userAgent: window.navigator.userAgent,
            deviceid: getDeviceId(),
            userUuid: localStorage.getItem('WX_LOGIN_UUID') || '',
            nfhSpreadId
        },
        success: res => {
        }
    });
}



// WEBPACK FOOTER //
// ./src/js/savePoints.js